import {
    USER_CHOOSE_CURRENT_FRUI_PFXH,
} from './constants';
  
export function chooseCurrentFrui_pfxh(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_PFXH,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_PFXH:
        return {
          ...state,
          currentFrui_pfxh:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_pfxh.js